module.exports = __webpack_public_path__ + "img/01-default.9ab3d3b4.png";